import { createOrg } from "../../apis/ext";
import { useSmartMutation } from "../../apiHooks/useSmartMutation";

const DEFAULT_ORIGIN_URL = "https://www.linkedin.com/sales/search/company";

const buildLinkedinUrl = ({ linkedinUrl, companyId, companyIdentifier }) => {
  if (linkedinUrl) {
    return linkedinUrl;
  }
  const id = companyId ?? companyIdentifier;
  if (id) {
    return `https://www.linkedin.com/company/${id}`;
  }
  return null;
};

export const useCreateOrg = ({ workspaceId, originUrl = DEFAULT_ORIGIN_URL, onSuccess, onError } = {}) => {
  const mutationFn = ({ linkedinUrl, companyId, companyIdentifier }) => {
    const resolvedLinkedinUrl = buildLinkedinUrl({ linkedinUrl, companyId, companyIdentifier });

    if (!resolvedLinkedinUrl) {
      throw new Error("A LinkedIn company URL or identifier is required to create an organization");
    }

    return createOrg({
      data: {
        organization: { linkedin_url: resolvedLinkedinUrl },
        origin_url: originUrl,
      },
      options: workspaceId
        ? {
            headers: { "X-Workspace-Id": workspaceId },
          }
        : undefined,
    });
  };

  return useSmartMutation("create_org", mutationFn, {
    onSuccess,
    onError,
  });
};
